const $masthead = $('header.masthead'),
    $sticky = $masthead.find('.masthead__inner'),
    classFixed = 'masthead--fixed',
    classVisible = 'masthead--visible';

let lastScrollTop = 0;

function stickyMasthead() {
    let scrolledDistance = $(document).scrollTop(),
        scrollDirection = 'down';

    if (scrolledDistance < lastScrollTop) {
        scrollDirection = 'up';
    }

    if (scrolledDistance > $masthead.outerHeight() + $masthead.offset().top) {
        if (!$masthead.hasClass(classFixed)) {
            $masthead.addClass(classFixed);
        }

        if ('up' === scrollDirection) {
            if (!$masthead.hasClass(classVisible)) {
                $masthead.addClass(classVisible);
            }
        } else {
            if ($masthead.hasClass(classVisible)) {
                $masthead.removeClass(classVisible);
            }
        }
    } else {
        if ($masthead.hasClass(classFixed)) {
            $masthead.removeClass(classFixed);
        }
    }

    lastScrollTop = scrolledDistance;
}

$(document).on('scroll', stickyMasthead);